import React from 'react';
import NewList from '../../Components/Property/NewList';

/** shows the random properties on the dynamic content component */
function RandomProperties(props) {
    return (
        <NewList properties={props.data.properties} />
    )
}
export default RandomProperties;